import SingleTextLoader from 'organisms/Loaders/SingleTextLoader';
import { prettifyPhoneNumber } from 'util';

export default function ({ item, isLoading }) {
  if (isLoading) return <SingleTextLoader />;

  const phone = item?.user?.phone;
  if (!phone) return <p>-</p>;

  const { country, number } = phone;
  return (
    <p>{prettifyPhoneNumber({ number, countryCode: country.code.value })}</p>
  );
}
